import { defaultFeatureFlags, FeatureFlags, FeatureStatus, featureStatusMap } from '../config/features';

export const isFeatureFlag = (possibleFeatureFlag: string): possibleFeatureFlag is FeatureFlags =>
  !!defaultFeatureFlags[possibleFeatureFlag as FeatureFlags];

export const isFeatureStatus = (possibleFeatureStatus: string): possibleFeatureStatus is FeatureStatus =>
  !!featureStatusMap[possibleFeatureStatus as FeatureStatus];

export const shouldShowFeature = (status: FeatureStatus): boolean => status === 'active';
